import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import React, { useRef, useEffect } from 'react';
import { projectsData } from '../../stores/projectsStore';

const Link = observer(() => {
    let linkRef: React.RefObject<HTMLInputElement> = useRef(null);
    // if(!linkRef) return;
    useEffect(() => {
        // let link = document.getElementById('link');
        if (linkRef.current) {
            linkRef.current.select();
        }
    });

    let copyLink = () => {
        if (linkRef.current) {
            linkRef.current.select();
        }
        document.execCommand('copy');
    };
    return (
        <div className="link-preview" style={toJS(projectsData.link.style)} onClick={(e) => e.stopPropagation()}>
            <input type="text" defaultValue={projectsData.link.link} ref={linkRef} id="link" />
            <i className="material-icons link" onClick={copyLink}>
                file_copy
            </i>

            <a href={projectsData.link.link} target="_blank">
                <i className="material-icons link open-link">open_in_new</i>
            </a>
        </div>
    );
});
export default Link;
